import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OpusAgentFieldsFragment = { __typename?: 'OpusAgent', id: string, createdAt: string, name: string, emoji: string, instructions: string, suggestedQuestions: Array<string>, archivedAt?: string | null, avatarKind?: Types.OpusAgentAvatarKind | null, avatarBotShape?: string | null, avatarBotColor?: string | null, avatarImageUrl?: string | null, template?: { __typename?: 'OpusAgentTemplate', id: string, key: string, description: string } | null, schedule?: { __typename?: 'OpusAgentSchedule', rrule: string, tzid: string, prompt: string, enabled: boolean, nextFireAt?: string | null, summary: string, runsAsViewer: boolean } | null };

export type OpusAgentsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OpusAgentsQuery = { __typename?: 'Query', OpusAgents: Array<{ __typename?: 'OpusAgent', id: string, createdAt: string, name: string, emoji: string, instructions: string, suggestedQuestions: Array<string>, archivedAt?: string | null, avatarKind?: Types.OpusAgentAvatarKind | null, avatarBotShape?: string | null, avatarBotColor?: string | null, avatarImageUrl?: string | null, template?: { __typename?: 'OpusAgentTemplate', id: string, key: string, description: string } | null, schedule?: { __typename?: 'OpusAgentSchedule', rrule: string, tzid: string, prompt: string, enabled: boolean, nextFireAt?: string | null, summary: string, runsAsViewer: boolean } | null }> };

export type SetOpusAgentArchivedMutationVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
  archived: Types.Scalars['Boolean']['input'];
}>;


export type SetOpusAgentArchivedMutation = { __typename?: 'Mutation', setOpusAgentArchived: { __typename?: 'OpusAgentResult', success: boolean, error?: { __typename?: 'Error', code: string, message?: string | null } | null, agent?: { __typename?: 'OpusAgent', id: string, createdAt: string, name: string, emoji: string, instructions: string, suggestedQuestions: Array<string>, archivedAt?: string | null, avatarKind?: Types.OpusAgentAvatarKind | null, avatarBotShape?: string | null, avatarBotColor?: string | null, avatarImageUrl?: string | null, template?: { __typename?: 'OpusAgentTemplate', id: string, key: string, description: string } | null, schedule?: { __typename?: 'OpusAgentSchedule', rrule: string, tzid: string, prompt: string, enabled: boolean, nextFireAt?: string | null, summary: string, runsAsViewer: boolean } | null } | null } };

export const OpusAgentFieldsFragmentDoc = gql`
    fragment OpusAgentFields on OpusAgent {
  id
  createdAt
  name
  emoji
  instructions
  suggestedQuestions
  archivedAt
  avatarKind
  avatarBotShape
  avatarBotColor
  avatarImageUrl
  template {
    id
    key
    description
  }
  schedule {
    rrule
    tzid
    prompt
    enabled
    nextFireAt
    summary
    runsAsViewer
  }
}
    `;
export const OpusAgentsDocument = gql`
    query OpusAgents {
  OpusAgents {
    ...OpusAgentFields
  }
}
    ${OpusAgentFieldsFragmentDoc}`;

/**
 * __useOpusAgentsQuery__
 *
 * To run a query within a React component, call `useOpusAgentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpusAgentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpusAgentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOpusAgentsQuery(baseOptions?: Apollo.QueryHookOptions<OpusAgentsQuery, OpusAgentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpusAgentsQuery, OpusAgentsQueryVariables>(OpusAgentsDocument, options);
      }
export function useOpusAgentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpusAgentsQuery, OpusAgentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpusAgentsQuery, OpusAgentsQueryVariables>(OpusAgentsDocument, options);
        }
export type OpusAgentsQueryHookResult = ReturnType<typeof useOpusAgentsQuery>;
export type OpusAgentsLazyQueryHookResult = ReturnType<typeof useOpusAgentsLazyQuery>;
export type OpusAgentsQueryResult = Apollo.QueryResult<OpusAgentsQuery, OpusAgentsQueryVariables>;
export const SetOpusAgentArchivedDocument = gql`
    mutation SetOpusAgentArchived($id: UUID!, $archived: Boolean!) {
  setOpusAgentArchived(id: $id, archived: $archived) {
    success
    error {
      code
      message
    }
    agent {
      ...OpusAgentFields
    }
  }
}
    ${OpusAgentFieldsFragmentDoc}`;
export type SetOpusAgentArchivedMutationFn = Apollo.MutationFunction<SetOpusAgentArchivedMutation, SetOpusAgentArchivedMutationVariables>;

/**
 * __useSetOpusAgentArchivedMutation__
 *
 * To run a mutation, you first call `useSetOpusAgentArchivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOpusAgentArchivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOpusAgentArchivedMutation, { data, loading, error }] = useSetOpusAgentArchivedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      archived: // value for 'archived'
 *   },
 * });
 */
export function useSetOpusAgentArchivedMutation(baseOptions?: Apollo.MutationHookOptions<SetOpusAgentArchivedMutation, SetOpusAgentArchivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetOpusAgentArchivedMutation, SetOpusAgentArchivedMutationVariables>(SetOpusAgentArchivedDocument, options);
      }
export type SetOpusAgentArchivedMutationHookResult = ReturnType<typeof useSetOpusAgentArchivedMutation>;
export type SetOpusAgentArchivedMutationResult = Apollo.MutationResult<SetOpusAgentArchivedMutation>;
export type SetOpusAgentArchivedMutationOptions = Apollo.BaseMutationOptions<SetOpusAgentArchivedMutation, SetOpusAgentArchivedMutationVariables>;